import type { UserConnection } from "@/hooks/useConnections";
import { deniedFromMetadata } from "@/lib/health/permissionState";

export const connectionGroups: Record<string, string> = {
  dropbox: "knowledge", todoist: "calendar", trello: "calendar", slack: "messages", microsoft_teams: "messages",
  google_contacts: "calendar", microsoft_contacts: "calendar", apple_contacts: "calendar", microsoft_todo: "calendar", apple_reminders: "calendar",
  google_calendar: "calendar", outlook: "calendar", apple_calendar: "calendar", google_tasks: "calendar",
  gmail: "messages", outlook_mail: "messages", whatsapp: "messages",
  strava: "health", apple_health: "health", health_connect: "health",
  notion: "knowledge", google_drive: "knowledge", onedrive: "knowledge", spotify: "entertainment",
};
export function connectionNeedsAttention(connection: UserConnection | null | undefined): boolean {
  if (!connection) return false;
  if (connection.status !== "active") return true;
  if ((connection.provider === "apple_health" || connection.provider === "health_connect") && deniedFromMetadata(connection.provider_metadata).length > 0) return true;
  return connection.last_sync_status !== null && !["ok", "success", "empty"].includes(connection.last_sync_status);
}
